<script>
import con from '@services/connection'
import { cadastroAtivo, acoesLoteConsolidador } from '@constants/URL'
import Title from '@components/section-title'
import Warning from '@/src/modules/power-bi/components/warning-bi/warning-bi.vue'

import { GlobalBus } from '@services/bus'
import {
  MODAL,
  RELOAD,
  CLASSES_SIMULADOR,
  FEATURES,
  CANT_ACCESS_FUNCTION,
} from '@constants/Text'
import Vue from 'vue'
import rules from '@constants/Rules'
import { possivelJSON } from '@utils/Format'
import TagField from '@components/tags-field'
import apiInstituicoes from '@api/instituicoes'
import apiContaBancaria from '@api/contaBancaria'
import { apiConsolidatorClientAssets } from '@modules/consolidator/api/apiConsolidatorClientAssets'

export default {
  components: { Title, TagField, Warning },
  data() {
    return {
      rules,
      apiInstituicoes,
      CLASSES_SIMULADOR,
      busModal: new Vue(),
      loading: false,
      loading_accounts: false,
      ativos: [],
      campo: '',
      clienteModal: null,
      erros: [],
      sucessos: [],
      subclasses_ativos: {},
      classe: '',
      modoIndividual: false,
      classeLote: '',
      subclasseLote: null,
      portfolio: '',
      comentario: '',
      tag: [],
      contas: [],
      conta: {},
      nome_instituicao: '',
      novaInstituicao: null,
      novaInstituicaoConta: '',
      isento_fee: false,
      isento_ir: false,
      desconsiderar_rentabilidade: false,
    }
  },
  computed: {
    cliente() {
      return this.clienteModal || this.$currentClient() || {}
    },
    subclasses() {
      let aux = []
      aux = this.$store.getters['subclasse/listagem']
      return aux
    },
    title() {
      const options = {
        excluir: 'Excluir ativos',
        alterar: 'Alterar ativos',
      }

      return options[this.campo] || options.alterar
    },
    buttonOptions() {
      if (this.campo === 'excluir') {
        return 'Excluir'
      }
      return 'Salvar'
    },
    temMultiplosAtivos() {
      return this.ativos.length > 1
    },
    subclassesLote() {
      const listagem = this.$store.getters['subclasse/listagem']
      if (!this.classeLote) {
        return listagem
      }
      return listagem.filter((item) => {
        return item.classe === this.classeLote
      })
    },
    sugestoesPortfolios() {
      const optionsFields =
        this.$store.getters['consolidator/walletAnalysisOptionsFields'] || []
      const nomePortfolioField = optionsFields.find(
        (field) => field.key === 'nome_portfolio'
      )
      if (nomePortfolioField && Array.isArray(nomePortfolioField.items)) {
        return nomePortfolioField.items
      }
      return this.$store.getters['clientAssets/getPortfolios'](this.cliente.id)
    },
    maxWidth() {
      if (this.campo === 'subclasse') {
        return this.modoIndividual ? '900px' : '600px'
      }
      return '600px'
    },
    listaInstituicoes() {
      return this.$store.getters['instituicoes/lista']
    },
    canEditDesconsiderarRentabilidade() {
      return !this.$currentUser().IS_CLIENTE
    },
  },
  created() {
    GlobalBus.$on(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.ACOES_LOTE_ATIVOS_CONSOLIDADOR, this.open)
  },
  methods: {
    clear() {
      this.erros = []
      this.sucessos = []
      this.subclasses_ativos = {}
      this.classe = ''
      this.modoIndividual = false
      this.classeLote = ''
      this.subclasseLote = null
      this.contas = []
      this.portfolio = ''
      this.comentario = ''
      this.tag = []
      this.conta = {}
      this.nome_instituicao = ''
      this.novaInstituicao = null
      this.novaInstituicaoConta = ''
      this.isento_fee = false
      this.isento_ir = false
      this.desconsiderar_rentabilidade = false
    },
    open({ ativos, campo }) {
      this.clear()

      this.ativos = this.formatarAtivos(ativos || [])
      this.campo = campo

      if (campo === 'subclasse') {
        this.prefillLoteFromAtivos()
      }

      if (campo === 'instituicao') {
        this.carregarContas()
        apiInstituicoes.carregar()
      }

      this.busModal.$emit('dialog', true)
    },
    formatarAtivos(ativos) {
      ativos = JSON.parse(JSON.stringify(ativos))
      const aux = ativos.map((item) => {
        item.classe = item.CI || item._office_class || item.classe
        this.calcSubclassesAtivo(item)

        return item
      })
      return aux
    },
    async salvar() {
      // campos rota editar
      // cadastroAtivo.ativos.editar ou cadastroAtivo.profissional + ativo['id']
      /**
       * id_conta
       * id_cliente_app
       * nome_instituicao
       * dados_ativo Dic com dados
       * ativo_novo
       * id
       * id_ativo_cliente
       */
      // campos rota transferir
      // cadastroAtivo.ativos.transferir ou cadastroAtivo.profissional + ativo['id']
      /**
       * id_conta_anterior
       * id_conta_nova
       * id_conta
       * instituicao
       * dados_ativo
       * id
       * id_ativo_cliente
       * id_cliente_app -> somente para cliente
       */

      if (!this.$refs.form.validate()) {
        return
      }

      const map = {
        classe: this.alterarClasse,
        subclasse: this.alterarSubclasse,
        instituicao: this.alterarInstituicao,
        portfolio: this.alterarPortfolio,
        simulacao: this.enviarSimulacao,
        comentario: this.alterarComentario,
        tag: this.adicionarTags,
        isento_fee: this.alterarIsentoFee,
        isento_ir: this.alterarIsentoIr,
        desconsiderar_rentabilidade: this.alterarDesconsiderarRentabilidade,
        excluir: this.deleteAssets,
      }

      map[this.campo]()
    },
    async alterarClasse() {
      const dados = {
        classes: this.ativos.map((item) => {
          return {
            id: item.id,
            classe: item.classe,
            subclasse: null,
          }
        }),
      }
      this.salvarAlteracoes(dados)
    },
    async alterarSubclasse() {
      const classes = this.modoIndividual
        ? this.ativos.map((item) => {
            return {
              id: item.id,
              classe: item.classe,
              subclasse: item.subclasse,
            }
          })
        : this.ativos.map((item) => {
            return {
              id: item.id,
              classe: this.classeLote,
              subclasse: this.subclasseLote || null,
            }
          })
      this.salvarAlteracoes({ classes })
    },
    prefillLoteFromAtivos() {
      if (!this.ativos.length) {
        return
      }
      const primeiro = this.ativos[0]
      const todasMesmaClasse = this.ativos.every((ativo) => {
        return ativo.classe === primeiro.classe
      })
      if (!todasMesmaClasse || !primeiro.classe) {
        return
      }
      this.classeLote = primeiro.classe
      const todasMesmaSubclasse = this.ativos.every((ativo) => {
        return ativo.subclasse === primeiro.subclasse
      })
      const subclasseComum = primeiro.subclasse || null
      this.subclasseLote = todasMesmaSubclasse ? subclasseComum : null
    },
    onClasseLoteChange() {
      const subclasseValida = this.subclassesLote.find((item) => {
        return item.subclasse === this.subclasseLote
      })
      if (!subclasseValida) {
        this.subclasseLote = null
      }
    },
    onSubclasseLoteChange() {
      if (this.classeLote || !this.subclasseLote) {
        return
      }
      const correspondente = this.subclasses.find((item) => {
        return item.subclasse === this.subclasseLote
      })
      if (correspondente && correspondente.classe) {
        this.classeLote = correspondente.classe
      }
    },
    async alterarInstituicao() {
      if (!this.conta.id_conta) {
        this.$showSnack({
          text: 'É necessário selecionar uma conta',
          button: true,
        })
        return
      }

      let idContaNova = 0
      if (this.novaInstituicao && this.novaInstituicao.id_banco) {
        const r = await this.adicionarContaPorInstituicao()
        if (r.status === 200) {
          idContaNova = r.value
        } else {
          this.$showSnack({
            text: r.message,
            button: true,
          })
          return
        }
      }

      let instituicao = this.conta.label
      if (this.conta.label === 'Outros') {
        if (this.novaInstituicao && this.novaInstituicao.nome) {
          instituicao = this.novaInstituicao.nome
        } else {
          instituicao = this.novaInstituicao
        }
      }
      instituicao = instituicao || this.conta.label
      instituicao =
        (idContaNova ? this.novaInstituicao.nome : instituicao) || instituicao

      const dados = {
        id_conta: idContaNova || this.conta.id_conta || -1,
        corretora: instituicao,
      }
      this.salvarAlteracoes(dados)
    },
    async alterarPortfolio() {
      if (this.$refs.combo_nome_portfolio) {
        this.$refs.combo_nome_portfolio.blur()
      }
      this.$nextTick(() => {
        if (!this.portfolio) {
          this.$showSnack({
            text: 'É necessário informar um nome de portfólio',
            button: true,
          })
          return
        }
        const dados = {
          nome_portfolio: this.portfolio,
        }
        this.salvarAlteracoes(dados)
      })
    },
    enviarSimulacao(modo = 'manual') {
      const lista = this.ativos.map((item) => {
        return {
          nome_ativo: item.nome_ativo,
          classe: item.CI || item.classe,
          subclasse: item.subclasse,
          modo: 'R$',
          tipo: item.Tipo,
          referencia: item.referencia || item.CNPJ,
          id_carteira_recomendada: null,
          origem: 'carteira-atual',
          valor: item['Saldo Bruto'],
          pl_atual: item['Saldo Bruto'],
          atual: true,
        }
      })

      if (!this.$access[FEATURES.SIMULADOR]) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }

      const page = `simulador.${modo}`
      if (this.$route.name !== page) {
        this.$router.push({
          name: page,
          params: {
            add_assets: lista,
          },
        })
      }
    },
    async alterarComentario() {
      if (!this.comentario) {
        this.$showSnack({
          text: 'É necessário inserir algum comentário',
          button: true,
        })
        return
      }
      const dados = {
        comentario: this.comentario,
      }
      this.salvarAlteracoes(dados)
    },
    async adicionarTags() {
      if (!this.tag.length) {
        this.$showSnack({
          text: 'Inclua pelo menos uma tag',
          button: true,
        })
        return
      }
      const dados = {
        tags: JSON.stringify(this.tag),
      }
      this.salvarAlteracoes(dados)
    },
    async alterarIsentoFee() {
      const dados = {
        isento_fee: this.isento_fee,
      }
      this.salvarAlteracoes(dados)
    },
    async alterarIsentoIr() {
      const dados = {
        isento: this.isento_ir,
      }
      this.salvarAlteracoes(dados)
    },
    async alterarDesconsiderarRentabilidade() {
      const dados = {
        desconsiderar_rentabilidade: this.desconsiderar_rentabilidade,
      }
      this.salvarAlteracoes(dados)
    },
    async salvarAlteracoes(dados = {}) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.erros = []

      const data = {
        dados_ativo: JSON.stringify(dados),
        ids_ativos: this.ativos.map((item) => {
          return item.id
        }),
      }

      let url
      if (this.$currentUser().IS_CLIENTE) {
        url = acoesLoteConsolidador.cliente.ativo
      } else {
        data['id_cliente_app'] = this.cliente.id
        url = acoesLoteConsolidador.profissional.ativo
      }

      const r = await con.put(url, data)

      this.loading = false

      if (r.status === 200) {
        GlobalBus.$emit(RELOAD.ASSETS_ONLY, true)
        this.$store.dispatch('consolidator/setClientDataOutdated', true)
        this.busModal.$emit('dialog', false)
      } else {
        this.erros.push(r)
      }

      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    async carregarContas() {
      let data = {
        id_cliente_app: this.cliente.id,
      }
      this.loading_accounts = true
      const r = await con.post(
        this.$currentUser().IS_CLIENTE
          ? cadastroAtivo.bancos.listar_client
          : cadastroAtivo.bancos.listar,
        data
      )
      this.loading_accounts = false
      if (r && r.status === 200) {
        let values = []
        if (possivelJSON(r.value).length) {
          values = possivelJSON(r.value).map((v, i) => {
            return {
              label: v.nome,
              value: `Conta: ${v.conta || v.cpf || v.email || '00000' + i} - ${
                v.nome
              }`,
              id_conta: v.id_conta,
              num_conta: v.conta || v.cpf || v.email,
            }
          })
        }

        values = values.filter((v) => {
          return v.label.toLowerCase() !== 'outros'
        })

        if (
          !values.find((v) => {
            return v.label === 'Outros'
          })
        ) {
          values.push({
            label: 'Outros',
            value: 'Outros',
            id_conta: -1,
          })
        }
        this.contas = values
      } else {
        this.contas = [{ label: 'Outros', value: 'Outros', id_conta: -1 }]
      }
    },
    applyClasseToAll(originIndex) {
      const origin = this.ativos[originIndex]
      if (!origin || !origin.classe) return
      for (let i = originIndex + 1; i < this.ativos.length; i++) {
        const ativo = this.ativos[i]
        if (ativo.classe === origin.classe) continue
        this.$set(ativo, 'classe', origin.classe)
        this.calcSubclassesAtivo(ativo)
      }
    },
    applySubclasseToFollowing(originIndex) {
      const origin = this.ativos[originIndex]
      if (!origin || !origin.subclasse) return
      for (let i = originIndex + 1; i < this.ativos.length; i++) {
        const ativo = this.ativos[i]
        if (ativo.classe !== origin.classe) {
          this.$set(ativo, 'classe', origin.classe)
          this.calcSubclassesAtivo(ativo)
        }
        this.$set(ativo, 'subclasse', origin.subclasse)
      }
    },
    calcSubclassesAtivo(ativo) {
      let aux = []
      if (ativo.classe) {
        aux = this.$store.getters['subclasse/listagem'].filter((item) => {
          return item.classe === ativo.classe
        })
      } else {
        aux = this.$store.getters['subclasse/listagem']
      }

      // Verificar se não existe a subclasse carregada do ativo.
      const atual = aux.find((item) => {
        return item.subclasse === ativo.subclasse
      })
      if (!atual && ativo.subclasse) {
        this.$set(ativo, 'subclasse', null)
      }

      this.$set(this.subclasses_ativos, ativo.id, aux)
    },
    /**
     * Adicionar conta nao automatica utilizando o nome padronizado de uma corretora
     * Ou permitindo adicionar um nome qualquer.
     */
    async adicionarContaPorInstituicao() {
      // Se eh uma instituicao padrao selecionada
      if (this.novaInstituicao.id_banco) {
        const data = {
          id_banco: this.novaInstituicao.id_banco,
          conta: this.novaInstituicaoConta,
        }

        const r = await apiContaBancaria.salvarContaNaoAutomatica(
          data,
          this.cliente,
          this.$currentUser()
        )

        return r
      }

      return {
        status: 400,
        message: 'Instituição não é válida.',
        value: {},
      }
    },
    async deleteAssets() {
      if (this.loading) {
        return
      }

      this.erros = []
      this.loading = true

      const idsAtivos = this.ativos.map((ativo) => ativo.id)
      const data = {
        idCliente: this.cliente.id,
        idsAtivos: idsAtivos,
      }

      const r = await apiConsolidatorClientAssets.deleteInBatch(data)

      this.loading = false

      if (r.status === 200) {
        this.busModal.$emit('dialog', false)
        GlobalBus.$emit(RELOAD.ASSETS_ONLY)
      } else {
        this.erros.push(r)
      }

      this.$showSnack({
        text: r.message,
        button: true,
        color: r.status === 200 ? 'success' : 'error',
      })

      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" persistent centerScreen :maxWidth="maxWidth">
    <Title :title="title" :subtitle="`${ativos.length} ativos selecionados`" />
    <v-form ref="form" @submit.prevent>
      <div>
        <template v-if="campo === 'classe'">
          <v-select
            v-model="classe"
            label="Classe*"
            placeholder="Selecione a classe*"
            :items="CLASSES_SIMULADOR"
            :rules="[rules.required]"
          />
        </template>

        <template v-if="campo === 'subclasse'">
          <template v-if="!modoIndividual">
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="classeLote"
                  label="Classe*"
                  placeholder="Selecione a classe*"
                  :items="CLASSES_SIMULADOR"
                  :rules="[rules.required]"
                  :menu-props="{ offsetY: true }"
                  @change="onClasseLoteChange"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="subclasseLote"
                  label="Subclasse"
                  :items="subclassesLote"
                  item-text="subclasse"
                  item-value="subclasse"
                  :menu-props="{ offsetY: true }"
                  @change="onSubclasseLoteChange"
                />
              </v-col>
            </v-row>
          </template>

          <v-checkbox
            v-if="temMultiplosAtivos"
            v-model="modoIndividual"
            label="Preciso definir valores diferentes por ativo"
            hide-details
            class="mt-0 mb-4"
          />

          <v-simple-table v-if="modoIndividual">
            <template v-slot>
              <thead>
                <tr>
                  <th>Nome ativo</th>
                  <th style="width: 250px">Classe</th>
                  <th style="width: 250px">Subclasse</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(ativo, index) in ativos"
                  :key="index"
                  class="acoes-lote-ativos-consolidador__row"
                >
                  <td> {{ ativo.nome_ativo || '—' }} </td>
                  <td>
                    <v-select
                      v-model="ativo.classe"
                      label="Classe*"
                      placeholder="Selecione a classe*"
                      :items="CLASSES_SIMULADOR"
                      :rules="[rules.required]"
                      :menu-props="{ offsetY: true }"
                      @change="calcSubclassesAtivo(ativo, $event)"
                    >
                      <template v-slot:append>
                        <v-tooltip
                          v-if="temMultiplosAtivos"
                          bottom
                          open-delay="150"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              :ripple="false"
                              class="acoes-lote-ativos-consolidador__apply-btn"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="applyClasseToAll(index)"
                            >
                              <v-icon small>mdi-arrow-down</v-icon>
                            </v-btn>
                          </template>
                          <span>Aplicar aos próximos ativos</span>
                        </v-tooltip>
                        <v-icon>mdi-menu-down</v-icon>
                      </template>
                    </v-select>
                  </td>
                  <td>
                    <v-select
                      v-model="ativo.subclasse"
                      label="Subclasse"
                      :items="subclasses_ativos[ativo.id]"
                      item-text="subclasse"
                      item-value="subclasse"
                      :menu-props="{ offsetY: true }"
                    >
                      <template v-slot:append>
                        <v-tooltip
                          v-if="temMultiplosAtivos"
                          bottom
                          open-delay="150"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              :ripple="false"
                              class="acoes-lote-ativos-consolidador__apply-btn"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="applySubclasseToFollowing(index)"
                            >
                              <v-icon small>mdi-arrow-down</v-icon>
                            </v-btn>
                          </template>
                          <span>Aplicar aos próximos ativos</span>
                        </v-tooltip>
                        <v-icon>mdi-menu-down</v-icon>
                      </template>
                    </v-select>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="campo === 'instituicao'">
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="conta"
                :items="contas"
                :label="
                  $currentUser().IS_CLIENTE
                    ? 'Selecione a sua conta*'
                    : 'Selecione a conta do cliente*'
                "
                :item-text="
                  (item) =>
                    item.num_conta
                      ? item.num_conta + ' - ' + item.label
                      : item.label
                "
                required
                :rules="[rules.required]"
                :loading="loading_accounts"
                return-object
              />
            </v-col>
            <v-col v-if="conta.label === 'Outros'" cols="12">
              <v-combobox
                v-model="novaInstituicao"
                label="Selecionar instituição*"
                :items="listaInstituicoes"
                autocomplete="off"
                :item-text="apiInstituicoes.formatarTexto"
                :filter="apiInstituicoes.filtrar"
                :menu-props="{
                  closeOnContentClick: true,
                }"
                :rules="[rules.required]"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <p class="text-primary mb-0"> Escolher Instituição </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:no-data>
                  <v-divider />
                </template>
              </v-combobox>
            </v-col>
            <v-col v-if="novaInstituicao && novaInstituicao.id_banco">
              <v-text-field
                v-model="novaInstituicaoConta"
                label="Identificador da conta (opcional)"
                hint="Número da conta, e-mail ou CPF"
              />
            </v-col>
          </v-row>
        </template>

        <template v-if="campo === 'portfolio'">
          <v-combobox
            ref="combo_nome_portfolio"
            v-model="portfolio"
            label="Portfólio"
            :items="sugestoesPortfolios"
            autocomplete="off"
          >
            <template v-slot:prepend-item>
              <div class="p-5">
                <p class="subtitle"> SUGESTÕES ENCONTRADAS </p>
              </div>
            </template>
          </v-combobox>
        </template>

        <template v-if="campo === 'comentario'">
          <p>
            Atenção: este comentário irá sobrescrever os comentários atuais em
            cada ativo.
          </p>
          <v-textarea v-model="comentario" label="Novo comentário" />
        </template>

        <template v-if="campo === 'tag'">
          <div>
            <p>
              As tags selecionadas abaixo serão adicionadas nos ativos, para
              remover as tags atuais é necessário editar individualmente cada
              ativo.
            </p>
            <TagField v-model="tag" />
          </div>
        </template>

        <template v-if="campo === 'simulacao'">
          <p> Selecione o modo do simulador: </p>
          <v-list>
            <v-list-item @click="enviarSimulacao('manual')">
              <v-list-item-icon>
                <v-icon> mdi-hand-back-left-outline </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Manual </v-list-item-title>
            </v-list-item>
            <v-list-item @click="enviarSimulacao('automatico')">
              <v-list-item-icon>
                <v-icon> mdi-rocket </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Automático </v-list-item-title>
            </v-list-item>
            <v-list-item @click="enviarSimulacao('guiado')">
              <v-list-item-icon>
                <v-icon> mdi-transit-transfer </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Guiado </v-list-item-title>
            </v-list-item>
            <v-list-item @click="enviarSimulacao('avancado')">
              <v-list-item-icon>
                <v-icon> mdi-tune-vertical </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Avançado </v-list-item-title>
            </v-list-item>
          </v-list>
        </template>

        <template v-if="campo === 'isento_fee'">
          <p> Definir os ativos como isentos no cálculo de Fee? </p>
          <v-checkbox v-model="isento_fee" label="Isento no Fee" />
        </template>

        <template v-if="campo === 'isento_ir'">
          <p> Definir os ativos como isentos de IR? </p>
          <v-checkbox v-model="isento_ir" label="Isento de IR" />
        </template>

        <template v-if="campo === 'desconsiderar_rentabilidade'">
          <p>
            Definir os ativos para serem desconsiderados na rentabilidade da
            carteira?
          </p>
          <v-checkbox
            v-model="desconsiderar_rentabilidade"
            label="Excluir da rentabilidade da carteira"
          />
        </template>

        <template v-if="campo === 'excluir'">
          <Warning type="break">
            <template v-slot:description
              >Você irá excluir permanentemente {{ ativos.length }} ativo(s) e
              suas movimentações. Você tem certeza?</template
            >
          </Warning>

          <v-expansion-panels class="mb-3">
            <v-expansion-panel>
              <v-expansion-panel-header> Ativos </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table>
                  <template v-slot>
                    <thead>
                      <tr>
                        <!-- <th>Nome ativo</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(ativo, index) in ativos" :key="index">
                        <td> {{ ativo.nome_ativo || '—' }} </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </div>
    </v-form>

    <div
      v-if="erros.length"
      style="max-height: 200px; overflow-y: auto; overflow-x: hidden"
    >
      <p class="subtitle"> ALERTAS: </p>
      <template v-for="(erro, index) in erros">
        <p :key="index" class="mb-0 ml-2">
          <small> {{ erro.message }} </small>
        </p>
      </template>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton
        :primary="campo !== 'excluir'"
        :alert="campo === 'excluir'"
        :loading="loading"
        @click="salvar"
      >
        {{ buttonOptions }}
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style scoped lang="sass">
.acoes-lote-ativos-consolidador
  &__apply-btn
    opacity: 0
    transition: opacity 0.15s

  &__row
    &:hover
      .acoes-lote-ativos-consolidador__apply-btn
        opacity: 1

    ::v-deep .v-select .mdi-menu-down
      transition: transform 0.3s ease

    ::v-deep .v-select.v-input--is-focused .mdi-menu-down
      color: var(--primary)

    ::v-deep .v-select.v-select--is-menu-active .mdi-menu-down
      transform: rotate(180deg)
      color: var(--primary)
</style>
